/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJaneStreetV1PfofJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JANE_STREET_V1_PFOF_JOB_STATE_ENTITY_NAME = 'exc.jane_street.v1.PfofJob';
export const excJaneStreetV1PfofJobStateEntity = new schema.Entity<ExcJaneStreetV1PfofJobState>(EXC_JANE_STREET_V1_PFOF_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'jobId' });

